module.exports = __webpack_public_path__ + "img/70m2.b76f7e4e.jpg";